import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { IndustryTermsQuery } from '@custom/schema';

export const useIndustryTermsQuery = () =>
  useStaticQuery(graphql(IndustryTermsQuery));
